module.exports = __webpack_public_path__ + "static/sandbox-min-f7688afece5f716eac4e8dc27b9c77c6.png";